import { type OrderEventActionBulkEnum } from '@klear/order-event/constants'
import {
  orderEventLifecycleActionsFrom,
  type OrderEventLifecycleAction,
  type OrderEventLifecycleState,
  type OrderEventLifecycleType
} from '@klear/order-event-lifecycle/lifecycle'

export type BulkActionCandidate = {
  type: OrderEventLifecycleType
  lifecycleState: OrderEventLifecycleState
}

export function isBulkActionCandidateEligible(
  action: OrderEventActionBulkEnum,
  candidate: BulkActionCandidate
): boolean {
  return orderEventLifecycleActionsFrom(candidate.type, candidate.lifecycleState).includes(
    action as OrderEventLifecycleAction
  )
}
